module.exports = __webpack_public_path__ + "img/706.37c494e8.png";